export default __webpack_public_path__ + "static/media/logo-atlassian.f2b0e857.svg";